/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiPaymentRepositoryStripeInitiatePaymentResponse
 */
export interface WebApiPaymentRepositoryStripeInitiatePaymentResponse {
    /**
     * 
     * @type {string}
     * @memberof WebApiPaymentRepositoryStripeInitiatePaymentResponse
     */
    url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiPaymentRepositoryStripeInitiatePaymentResponse
     */
    id?: string | null;
}

/**
 * Check if a given object implements the WebApiPaymentRepositoryStripeInitiatePaymentResponse interface.
 */
export function instanceOfWebApiPaymentRepositoryStripeInitiatePaymentResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiPaymentRepositoryStripeInitiatePaymentResponseFromJSON(json: any): WebApiPaymentRepositoryStripeInitiatePaymentResponse {
    return WebApiPaymentRepositoryStripeInitiatePaymentResponseFromJSONTyped(json, false);
}

export function WebApiPaymentRepositoryStripeInitiatePaymentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiPaymentRepositoryStripeInitiatePaymentResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': !exists(json, 'url') ? undefined : json['url'],
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function WebApiPaymentRepositoryStripeInitiatePaymentResponseToJSON(value?: WebApiPaymentRepositoryStripeInitiatePaymentResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
        'id': value.id,
    };
}

